import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

const Gender = ({ gender }) => (
  <li>{trans(`property_show.instant_booking_modal.gender.${gender}`)}</li>
);

Gender.propTypes = {
  gender: PropTypes.string.isRequired
};

export default Gender;
